import { css, CSSResult } from 'lit'
import { csColorFunctional, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const cseRating = {
  emptyColor: css`var(--cse-rating-empty-color, ${csColorText.muted})`,
  filledColor: css`var(--cse-rating-filled-color, ${csColorFunctional.highlight})`,
  columnGap: css`var(--cse-rating-column-gap, ${csSpacing.spacing04})`,
  disabledColor: css`var(--cse-rating-disabled-color, ${csColorText.muted})`
}

export const style: CSSResult = css`
  .cse-rating {
    column-gap: ${cseRating.columnGap};
    display: inline-flex;
    color: ${cseRating.filledColor};
  }

  .cse-rating[data-value="0"] {
    color: ${cseRating.emptyColor};
  }

  .disabled {
    color: ${cseRating.disabledColor};
  }
`
